<!-- components/MeetingsList.vue -->
<script>
import MeetingItem from './meeting-item.vue'
import PaginationButtons from '../pagination-buttons.vue'

export default {
  name: 'MeetingList',
  components: { MeetingItem, PaginationButtons },
  data() {
    return {
      filter: {
        search: this.$route.query.search || '',
        upcoming: this.$route.query.upcoming || '1', // standard: upcoming
      },
      meetings: [],
      page: Number(this.$route.query.page || 1),
      numPages: 1,
      numMeetings: 0,
      loading: false,
      error: null,
    }
  },
  watch: {
    filter: {
      handler() {
        this.page = 1
        this.pushQuery()
        this.fetchMeetings()
      },
      deep: true
    },
    page() {
      this.pushQuery()
      this.fetchMeetings()
    }
  },
  created() {
    this.fetchMeetings()
  },
  methods: {
    pushQuery() {
      const q = {}
      if (this.filter.search) q.search = this.filter.search
      if (this.filter.upcoming) q.upcoming = this.filter.upcoming
      if (this.page > 1) q.page = this.page
      try { this.$router.push({ query: q }) } catch(e) { /* noop */ }
    },
    fetchMeetings() {
      this.loading = true
      this.error = null

      const params = {
        page: this.page,
      }
      if (this.filter.search) params.search = this.filter.search
      if (this.filter.upcoming) params.upcoming = this.filter.upcoming

      this.$api.get('/meetings/', { params })
        .then((res) => {
          if ('results' in res.data) {
            this.meetings = res.data.results
            this.numMeetings = res.data.count ?? res.data.results.length
            // numPages: wenn dein Backend 'pages' nicht liefert, aus count/page_size ableiten oder leer lassen
            this.numPages = res.data.pages ?? Math.max(1, Math.ceil((res.data.count || 0) / (res.data.page_size || 1)))
          } else {
            // ohne Pagination
            this.meetings = res.data
            this.numMeetings = this.meetings.length
            this.numPages = 1
          }
        })
        .catch((err) => {
          this.error = err.response?.data?.detail || 'Fehler beim Laden der Meetings.'
        })
        .finally(() => { this.loading = false })
    },
    clearSearch()  { this.filter.search = '' },
  }
}
</script>

<template>
  <div class="container my-3">
    <!-- Filter / Toolbar -->
    <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
      <div class="input-group" style="max-width: 360px;">
        <input
          v-model.trim="filter.search"
          type="search"
          class="form-control"
          placeholder="Meeting suchen (Summary, Name)…"
          aria-label="Suche"
        />
        <button class="btn btn-outline-secondary" @click="clearSearch" :disabled="!filter.search"><i class="bi bi-x-lg"></i></button>
      </div>

      <div class="form-check form-switch ms-auto">
        <input class="form-check-input" type="checkbox" id="upcomingSwitch"
               v-model="filter.upcoming" true-value="1" false-value="">
        <label class="form-check-label" for="upcomingSwitch">Nur anstehende</label>
      </div>
    </div>

    <!-- Status -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden…</span>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <!-- Liste -->
    <div v-if="!loading && meetings.length">
        <MeetingItem
        v-for="(m, idx) in meetings" :key="m.ics_uid || m.id"
        :meeting="m"
        @update:meeting="$set(meetings, idx, $event)"
        />
    </div>

    <div v-if="!loading && !meetings.length" class="alert alert-info mt-4">
      Keine Meetings gefunden.
    </div>

    <!-- Pagination -->
    <pagination-buttons :page.sync="page" :num-pages="numPages" />
  </div>
</template>
